import { render } from "./BusCarInfoPrint.vue?vue&type=template&id=34bfe50c&scoped=true"
import script from "./BusCarInfoPrint.vue?vue&type=script&lang=js"
export * from "./BusCarInfoPrint.vue?vue&type=script&lang=js"

import "./BusCarInfoPrint.vue?vue&type=style&index=0&id=34bfe50c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bfe50c"]])

export default __exports__